import { useAllContactsList } from 'api/goodtrust/contact'
import { Button } from 'components/button/Button'
import { ContactCard } from 'components/contact/contactCard/ContactCard'
import { ItemGrid } from 'components/Grid'
import { Text } from 'components/Typography'
import { WizardSubtitle } from 'components/wizard/WizardTypography'
import { useTranslation } from 'next-i18next'
import { Fragment } from 'react'
import { getPaginationMeta } from 'utils/pagination'

export function ContactAllList(props: { title?: string }) {
  const { t } = useTranslation('trusted_contact')
  const { t: tCommon } = useTranslation()

  const myContacts = useAllContactsList()
  const meta = getPaginationMeta(myContacts)

  if (meta.isEmpty) return null
  return (
    <section>
      <WizardSubtitle>{props.title}</WizardSubtitle>
      <Text css={{ maxWidth: '548px', marginBottom: '1.5rem' }}>
        {t('trusted_contact.contact_all_list.desc')}
      </Text>
      <ItemGrid minItemWidth={236} css={{ marginBottom: '1rem' }}>
        {myContacts.data?.map((page, pageIndex) => {
          return (
            <Fragment key={pageIndex}>
              {page.json?.items?.map((item) => (
                <ContactCard
                  contact={item}
                  onChange={myContacts.mutate}
                  key={`contact_${item.uuid}`}
                />
              ))}
            </Fragment>
          )
        })}
      </ItemGrid>
      {!meta.isReachingEnd && (
        <Button
          type="button"
          variant="secondary"
          size="large"
          block
          loading={meta.isLoadingMore}
          onClick={meta.handleLoadMore}
        >
          {tCommon('common.load_more')}
        </Button>
      )}
    </section>
  )
}
